module.exports = __webpack_public_path__ + "AdProLTStd-Black.2a0a9d2bae82b2b3a913.ttf";


//////////////////
// WEBPACK FOOTER
// /home/alee/projects/egis-rse-dev/src/assets/fonts/AdProLTStd-Black.ttf
// module id = ../../../../../src/assets/fonts/AdProLTStd-Black.ttf
// module chunks = styles